//
// Copyright 2020 DXOS.org
//
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file dxos/field_options.proto.
 */
export const file_dxos_field_options = /*@__PURE__*/ fileDesc("ChhkeG9zL2ZpZWxkX29wdGlvbnMucHJvdG86RAoMcHJlc2VydmVfYW55Eh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxjAPiABKAhSC3ByZXNlcnZlQW55iAEBYgZwcm90bzM", [file_google_protobuf_descriptor]);
/**
 * @generated from extension: optional bool preserve_any = 8000;
 */
export const preserve_any = /*@__PURE__*/ extDesc(file_dxos_field_options, 0);
//# sourceMappingURL=field_options_pb.js.map